import React from 'react'
import Icon from '../../../ui/Icon/Icon'
import NoAvatar from '../../../ui/NoAvatar/NoAvatar'
import styles from './GiftsFund.module.scss'

function FundItemWithAvatar({ imageUrl, title, secondary, useSetAvatar = false }) {
  return (
    <div className={styles.itemWithAvatar}>
      {imageUrl ? (
        <img src={imageUrl} alt={title || ''} />
      ) : useSetAvatar ? (
        <div className={styles.itemSetAvatar} aria-hidden="true">
          <Icon name="th-large" weight="regular" />
        </div>
      ) : (
        <NoAvatar />
      )}
      <div className={styles.itemWithAvatarContent}>
        <p className={styles.itemWithAvatarTitle}>{title}</p>
        {secondary ? <p className={styles.itemWithAvatarMeta}>{secondary}</p> : null}
      </div>
    </div>
  )
}

export default FundItemWithAvatar
